// Match the images displayed by SearchHero, including legacy text-mode pages.
export function getContentfulHeroImageIds({ image, desktopImage, mobileImage, mode }: Pick<App.ComponentHeroImage, 'image' | 'desktopImage' | 'mobileImage' | 'mode'>) {
  const hasOverlayImages = !!(desktopImage?.id && mobileImage?.id)
  return {
    desktopId: mode === 'image-overlay' ? (hasOverlayImages ? desktopImage?.id : undefined) : image?.id,
    mobileId: mode === 'image-overlay' && hasOverlayImages ? mobileImage?.id : undefined,
  }
}
